import React from "react";
import classnames from "classnames";

import Image from "components/Image";

type Brand = {
  claimed: boolean;
  logo: string;
  name: string;
  tagline?: string;
};

type Props = {
  brand: Brand;
  className?: string;
};

const BrandLogoHeading = ({ brand, className }: Props) => {
  return (
    <div
      className={classnames("flex items-center", className)}
      style={{ minHeight: "70px" }}
    >
      {brand.logo && (
        <div
          style={{ height: 70, width: 70 }}
          className="elevation-low rounded-full border border-light-grey flex-shrink-0 overflow-hidden"
        >
          <Image
            src={brand.logo}
            sizes={[70]}
            alt={`Logo for the brand ${brand.name}`}
            disableLazyLoad
          />
        </div>
      )}
      <div className="ml-lg">
        <h1 className="heading--l">{brand.name}</h1>
        {!!brand.tagline && brand.claimed && (
          <div className="text-sm">{brand.tagline}</div>
        )}
      </div>
    </div>
  );
};

export default BrandLogoHeading;
